module.exports = __webpack_public_path__ + "static/media/Retângulo 714@3x.62473f4a.png";